// Bundled base locale `en-standard`.
//
// Purpose:
//  - instant first paint + offline fallback (it is the last link in the chained
//    backend, so the UI always has terms even if the network is down);
//  - the single source of truth for the `TermKey` types (see ../termKeys.ts).
//
// Keys are SEMANTIC and language-independent. `dose_count_*` use i18next plural
// suffixes and interpolate {{count}}.
//
// Only `en-standard` is bundled. Other locales (`en-clinical`, future `es-*`) load
// over HTTP and inherit missing keys via i18next `fallbackLng`, so the bundle stays
// small.
export const enStandard = {
  // Generic/default namespace — terms without a domain home live here. It is the
  // i18next `defaultNS`, so `t('app_title')` (no namespace) resolves from `cgt`.
  cgt: {
    app_title: 'CGT Dashboard',
    program: 'Program',
    site: 'Site',
    network: 'Network',
    save: 'Save',
    cancel: 'Cancel',
  },
  subject: {
    subject: 'Recipient',
    subject_plural: 'Recipients',
    caregiver: 'Care Partner',
    referring_phys: 'Referring Provider',
  },
  clinical_status: {
    deceased: 'Expired',
    adverse_event: 'Reaction',
    remission: 'Response',
    relapse: 'Recurrence',
    eligibility: 'Suitability',
  },
  manufacturing: {
    apheresis: 'Cell Collection',
    collection: 'Harvest',
    manufacturing: 'Production',
    cryopreservation: 'Freezing',
    disposition: 'Release',
    coi: 'Chain of Identity',
    coc: 'Chain of Custody',
    dose_count_one: '{{count}} dose',
    dose_count_other: '{{count}} doses',
    product: 'Therapy',
    infusion: 'Administration',
  },
  scheduling: {
    slot: 'Appointment',
    manufacturing_slot: 'Production Window',
    visit: 'Encounter',
  },
  consent: {
    informed_consent: 'Consent',
    protocol: 'Study Protocol',
    enrollment: 'Registration',
  },
} as const
